export default {
  data() {
    return {
      value: '', keyword: '', categories: [], selectedCategoryId: null,
      currentPage: 1, pageSize: 10, pagelist: [], totalItems: 0,
      categoriesLoading: false, categoriesError: false, contentLoading: false,
      contentError: false, requestSequence: 0,
      historyRandomSeed: `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`,
    }
  },
  computed: {
    selectedCategory() { return this.categories.find(item => item.id === this.selectedCategoryId) || null },
    selectedCategoryName() { return this.selectedCategory ? this.selectedCategory.name : '視頻分類' },
    renderList() { return this.pagelist },
    emptyMessage() {
      if (this.contentLoading || this.categoriesLoading) return '載入中…'
      if (this.contentError) return '內容載入失敗，請重試'
      return this.keyword ? '此分類沒有符合搜尋條件的視頻' : '此分類暫無視頻'
    },
  },
  created() {
    localStorage.removeItem('history_page_cache')
    this.getcatelist()
  },
  methods: {
    async getcatelist() {
      this.categoriesLoading = true
      this.categoriesError = false
      try {
        const response = await this.$http({ method: 'get', url: 'catelist' })
        if (!response || response.code !== 200) throw new Error('categories unavailable')
        const payload = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
        const rows = Array.isArray(payload) ? payload : payload && payload.data
        if (!Array.isArray(rows)) throw new Error('categories unavailable')
        this.categories = rows.map(item => ({ ...item, id: Number(item.id), name: String(item.name || item.cn_name || item.name_zh_cn || '') })).filter(item => item.id > 0 && item.name)
        if (!this.categories.some(item => item.id === this.selectedCategoryId)) this.selectedCategoryId = this.categories.length ? this.categories[0].id : null
        this.currentPage = 1
        await this.getpagelist()
      } catch (error) {
        this.categoriesError = true
        this.categories = []
        this.selectedCategoryId = null
        this.pagelist = []
        this.totalItems = 0
      } finally { this.categoriesLoading = false }
    },
    selectCategory(id) {
      const categoryId = Number(id)
      if (categoryId === this.selectedCategoryId || !this.categories.some(item => item.id === categoryId)) return
      this.selectedCategoryId = categoryId
      this.currentPage = 1
      return this.getpagelist()
    },
    search() {
      this.keyword = this.value.trim()
      this.currentPage = 1
      return this.getpagelist()
    },
    async getpagelist(page = this.currentPage) {
      const sequence = ++this.requestSequence
      this.currentPage = Number(page) || 1
      this.pagelist = []
      this.totalItems = 0
      this.contentError = false
      if (!this.selectedCategoryId) return
      this.contentLoading = true
      try {
        const response = await this.$http({ method: 'get', url: 'pagelist', data: {
          page: this.currentPage, limit: this.pageSize, cate_id: this.selectedCategoryId,
          keyword: this.keyword, random: 1, seed: this.historyRandomSeed,
        } })
        if (sequence !== this.requestSequence) return
        if (!response || response.code !== 200) throw new Error('content unavailable')
        const payload = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
        const rows = payload && (typeof payload.data === 'string' ? JSON.parse(payload.data) : payload.data)
        if (!Array.isArray(rows)) throw new Error('content unavailable')
        this.pagelist = rows
        this.totalItems = Number(payload.count) || 0
      } catch (error) {
        if (sequence === this.requestSequence) this.contentError = true
      } finally {
        if (sequence === this.requestSequence) this.contentLoading = false
      }
    },
  },
}
